<script setup lang="ts">
import { ref } from 'vue'
import { Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot } from '@headlessui/vue'
import { XMarkIcon } from '@heroicons/vue/24/outline'

const open = ref(true);

const props = defineProps<{
  title: string,
  description?: string,
  width?: string,
}>()

defineEmits<{
  (e: 'close'): void,
}>()
</script>

<template>
  <TransitionRoot as="template" :show="open" @afterLeave="$emit('close')">
    <Dialog as="div" class="relative z-10" @close="open = false">
      <div class="fixed inset-0 bg-black opacity-10"/>

      <div class="fixed inset-0 overflow-hidden">
        <div class="absolute inset-0 overflow-hidden">
          <div class="pointer-events-none fixed inset-y-0 right-0 flex max-w-full sm:pl-16">
            <TransitionChild as="template" enter="transform transition ease-in-out duration-500 sm:duration-700" enter-from="translate-x-full" enter-to="translate-x-0" leave="transform transition ease-in-out duration-500 sm:duration-700"
                             leave-from="translate-x-0" leave-to="translate-x-full">
              <DialogPanel :class="[
                'pointer-events-auto w-screen',
                width ? width : 'md:max-w-4xl',
              ]">
                <div class="relative flex h-full flex-col overflow-y-scroll bg-white dark:bg-gray-700 shadow-xl">
                  <div class="sticky z-40 top-0 bg-primary-600 dark:bg-primary-500 py-6 px-4 sm:px-6">
                    <div class="flex items-center justify-between">
                      <DialogTitle class="font-serif text-3xl italic text-white">
                        {{ props.title }}
                      </DialogTitle>
                      <div class="ml-3 flex h-7 items-center">
                        <button type="button" class="rounded-md bg-primary-600 dark:bg-primary-500 text-primary-200 hover:text-white focus:outline-none" @click="open = false">
                          <span class="sr-only">Close</span>
                          <XMarkIcon class="h-6 w-6" aria-hidden="true"/>
                        </button>
                      </div>
                    </div>
                    <div v-if="props.description" class="mt-1">
                      <p class="text-white">
                        {{ props.description }}
                      </p>
                    </div>
                  </div>
                  <div class="relative flex-1 py-6 px-4 sm:px-6">
                    <div class="absolute inset-0 py-6 px-4 sm:px-6 text-gray-900 dark:text-white">
                      <slot/>
                    </div>
                  </div>
                </div>
              </DialogPanel>
            </TransitionChild>
          </div>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>
